import React, { Component } from 'react'

export default class errorcomp extends Component {
    render() {
        return (
            <div>
                <h1>ESTO ES UNA PRUEBA</h1>
            </div>
        )
    }
}
